import React from 'react';
import { IconContainer } from './IconContainer';

const VerifiedIcon = (props) => {
    return (
        <IconContainer ariaLabel="verified" {...props}>
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.00004 14.6667C4.31804 14.6667 1.33337 11.682 1.33337 8.00001C1.33337 4.31801 4.31804 1.33334 8.00004 1.33334C11.682 1.33334 14.6667 4.31801 14.6667 8.00001C14.6667 11.682 11.682 14.6667 8.00004 14.6667ZM7.33537 10.6667L12.0487 5.95268L11.106 5.01001L7.33537 8.78134L5.44937 6.89534L4.50671 7.83801L7.33537 10.6667Z" fill="#55C36D"/>
            </svg>
        </IconContainer>
    )
}

export { VerifiedIcon };
